import { JetView } from 'webix-jet'; // Importing JetView for creating a Webix view
import { getCities } from 'models/cities'; // Importing function to get cities data
import { getTags } from 'models/tags'; // Importing function to get tags data
import { getPositions } from 'models/positions'; // Importing function to get positions data
import 'webix/photo'; // Importing Webix photo component
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from Webix

/**
 * Class representing a filter view for profile options.
 * @extends JetView
 */
export default class FilterPerfilOpcionesView extends JetView {
    /**
     * Configures the layout of the filter view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const screen = this.app.config.size; // Getting the screen size configuration

        // Defining layout sections with margins
        const left = { margin: 5, rows: [] };
        const center_left = { margin: 5, rows: [] };
        const center_right = { margin: 5, rows: [] };
        const right = { margin: 5, rows: [] };

        // Upper section layout with columns
        const upper_section = {
            cols: [
                left,
                { gravity: 0, minWidth: 10 },
                center_left,
                { gravity: 0, minWidth: 10 },
                center_right,
                { gravity: 0, minWidth: 10 },
                right,
            ],
        };

        // Button configuration for actions
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'), // Button label
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clears the form values
                    },
                },
                {
                    view: 'button', // Consult button
                    value: _('Consultar'), // Button label
                    hotkey: 'enter', // Shortcut key for the button
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Gets form values
                        this.app.callEvent('premiosPendientesPagar:filter', [
                            filterdata, // Calls event with filter data
                        ]);
                    },
                },
            ],
        };

        // Returning the main configuration for the form
        return {
            view: 'form',
            rows: [upper_section, buttons], // Combining upper section and buttons
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for fname field
            },
        };
    }
}

// FILE DOCUMENTED
